<template>
  <transition :name="`rotate${is_counter_clockwise ? '-counter-clockwise' : ''}`">
    <slot />
  </transition>
</template>

<script>

  export default {
    props: [
      'is_counter_clockwise', // is boolean
    ],
  }
</script>

<style>
  .rotate-enter-active, .rotate-leave-active {
    transition: all .25s ease-out;
  }
  .rotate-enter {
    opacity: 0;
    transform: rotate(-120deg);
  }
  .rotate-leave-to {
    opacity: 0;
    transform: rotate(90deg);
  }


  .rotate-counter-clockwise-enter-active, .rotate-counter-clockwise-leave-active {
    transition: all .25s ease-out;
  }
  .rotate-counter-clockwise-enter {
    opacity: 0;
    transform: rotate(90deg);
  }
  .rotate-counter-clockwise-leave-to {
    opacity: 0;
    transform: rotate(-120deg);
  }
</style>
